<template>
    <div class="pt-wrap">
        <div class="page-title">手机设备状态 <small>坐席手机设备的授权与在线状态</small></div>
        <!-- 数据统计 -->
        <div class="stat-row">
            <div class="stat-card">
                <div class="stat-label"><span class="dot" style="background:#4F46E5"></span>设备总数</div>
                <div class="stat-value">{{ statCard.total }}<span class="unit">台</span></div>
                <div class="stat-sub">当前筛选企微主体下全部设备</div>
            </div>
            <div class="stat-card">
                <div class="stat-label"><span class="dot" style="background:#10B981"></span>在线设备</div>
                <div class="stat-value">{{ statCard.online }}<span class="unit">台</span></div>
                <div class="stat-sub">近 5 分钟内有心跳上报</div>
            </div>
            <div class="stat-card">
                <div class="stat-label"><span class="dot" style="background:#64748B"></span>离线设备</div>
                <div class="stat-value">{{ statCard.offline }}<span class="unit">台</span></div>
                <div class="stat-sub">启用中但未连接</div>
            </div>
            <div class="stat-card">
                <div class="stat-label"><span class="dot" style="background:#EF4444"></span>已禁用</div>
                <div class="stat-value">{{ statCard.disabled }}<span class="unit">台</span></div>
                <div class="stat-sub">停用后不可接收分配</div>
            </div>
        </div>

        <!-- 工具栏 -->
        <div class="toolbar">
            <el-select class="ops-select" style="width:180px" v-model="searchdata.corp_id" @change="searchbtn" clearable placeholder="全部企微主体">
                <el-option v-for="(item, index) in corpList.data" :key="index" :label="item.corp_name" :value="item.id" />
            </el-select>
            <el-input class="search-box" v-model="searchdata.keyword" placeholder="搜索 imei / 手机别名 / 微信昵称…" clearable @input="searchbtn" @clear="searchbtn" />
            <div class="seg-filter">
                <button class="sf-btn" :class="{ active: searchdata.device_online === '' }" @click="onSeg('')">全部</button>
                <button class="sf-btn" :class="{ active: searchdata.device_online === 1 }" @click="onSeg(1)">在线</button>
                <button class="sf-btn" :class="{ active: searchdata.device_online === 0 }" @click="onSeg(0)">离线</button>
            </div>
            <el-select class="ops-select" style="width:130px" v-model="searchdata.device_category" clearable placeholder="全部类别" @change="searchbtn">
                <el-option v-for="(item, index) in options2.data" :key="index" :label="item.label" :value="item.value" />
            </el-select>
            <div class="spacer"></div>
        </div>

        <!-- 表格 -->
        <div class="table-wrap">
            <el-table :data="tableData.data" :row-class-name="rowClassName" class="seg-table" style="width: 100%">
                <el-table-column label="imei">
                    <template #default="scope"><span class="mono">{{ scope.row.imei }}</span></template>
                </el-table-column>

                <el-table-column label="手机别名">
                    <template #default="scope"><span class="cell-strong">{{ scope.row.device_name }}</span></template>
                </el-table-column>
                <el-table-column label="微信id">
                    <template #default="scope"><span class="mono">{{ scope.row.wx_user_id }}</span></template>
                </el-table-column>
                <el-table-column label="微信昵称">
                    <template #default="scope"><span class="muted-cell">{{ scope.row.wx_name }}</span></template>
                </el-table-column>
                <el-table-column label="所属主体">
                    <template #default="scope"><span class="muted-cell">{{ scope.row.corp_name || '—' }}</span></template>
                </el-table-column>
                <el-table-column label="手机设备状态" width="150px">
                    <template #default="scope">
                        <span class="ops-badge" :class="scope.row.device_online == 1 ? 'ops-badge-online' : 'ops-badge-offline'">
                            {{ scope.row.device_online == 1 ? '在线' : '离线' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="类别">
                    <template #default="scope">
                        <span class="badge" :class="catClass(scope.row.device_category)">{{ catName(scope.row.device_category) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template #default="scope">
                        <div class="ops-row-actions">
                            <button class="ops-link" @click="openwindow(scope.row)">修改</button>
                            <button class="ops-link danger" @click="delbtn(scope.row)">删除</button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pager">
                <el-pagination
                    :total="total"
                    :current-page="searchdata.page"
                    :page-size="searchdata.page_size"
                    layout="total, prev, next"
                    prev-text="上一页"
                    next-text="下一页"
                    @current-change="page_change"
                />
            </div>
        </div>
    </div>

    <!-- 添加 / 修改设备弹窗 -->
    <el-dialog
        v-model="isshowadd"
        :title="formdata.id ? '修改设备' : '添加设备'"
        width="460px"
        :close-on-click-modal="false"
        class="pt-dialog"
    >
        <div class="form-grid">
            <div class="form-row">
                <label class="form-label">手机别名<span class="req">*</span></label>
                <input class="form-input" v-model="formdata.device_name" placeholder="如：号卡助手-安乐" maxlength="20" />
            </div>
            <div class="form-row">
                <label class="form-label">设备类别<span class="req">*</span></label>
                <el-select v-model="formdata.device_category" clearable placeholder="设备类别" style="width:100%">
                    <el-option v-for="(item, index) in options2.data" :key="index" :label="item.label" :value="item.value" />
                </el-select>
            </div>
        </div>
        <template #footer>
            <div class="dialog-foot">
                <el-button class="btn-ghost" @click="isshowadd = false">取消</el-button>
                <el-button class="btn-primary" @click="suresub">保存</el-button>
            </div>
        </template>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog v-model="isshowdel" width="400px" :close-on-click-modal="false" class="pt-dialog-del">
        <h3 class="del-title">删除设备</h3>
        <p class="del-text">确认删除设备「<b>{{ delrow.data.wx_name }}</b>」？</p>
        <div class="alert-warn">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><path d="M12 9v4" /><path d="M12 17h.01" /></svg>
            <div>
                <b>删除后不可恢复，请谨慎操作</b>
                <p>请确认该设备已永不再使用。删除后设备上登录的企微账号将解除授权，如需再次接入必须重新扫码并重新配置。</p>
            </div>
        </div>
        <template #footer>
            <div class="dialog-foot">
                <el-button class="btn-ghost" @click="isshowdel = false">取消</el-button>
                <el-button class="btn-danger" @click="confirmdel">确认删除</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { newphonelist, newaddphone, newupdatesimple, newdelphone, newgetcomp2 } from '@/assets/js/common.js'

onMounted(() => {
    getlist()
    getcorplist()
})

// 企微主体下拉
const corpList = reactive({
    data: []
})
// 获取企微主体下拉
const getcorplist = () => {
    newgetcomp2().then((response) => {
        if (response.data.msg.code == 0) {
            corpList.data = response.data.data
        }
    })
}
// 类别
const options2 = reactive({
    data: [
        { value: 1, label: '客服' },
        { value: 2, label: '营销' },
    ],
})

// 搜索内容（接口参数）
const searchdata = reactive({
    corp_id: '',
    device_type: '',
    keyword: '',
    is_wecom_disabled: '',
    device_online: '',
    device_category: '',
    page: 1,
    page_size: 20,
})

// 统计卡片（接口返回）
const statCard = reactive({
    total: 0,
    online: 0,
    offline: 0,
    disabled: 0,
})

// 搜索（筛选条件变化时触发）
const searchbtn = () => {
    searchdata.page = 1
    getlist()
}

// 在线状态分段
const onSeg = (val) => {
    searchdata.device_online = val
    searchbtn()
}

// 列表数据
const tableData = reactive({
    data: []
})
// 总数
const total = ref(0)
// 获取列表
const getlist = () => {
    const obj = {}
    if (searchdata.corp_id !== '' && searchdata.corp_id != null) obj.corp_id = searchdata.corp_id
    if (searchdata.device_type !== '' && searchdata.device_type != null) obj.device_type = String(searchdata.device_type)
    if (searchdata.keyword !== '' && searchdata.keyword != null) obj.keyword = searchdata.keyword
    if (searchdata.is_wecom_disabled !== '' && searchdata.is_wecom_disabled != null) obj.is_wecom_disabled = String(searchdata.is_wecom_disabled)
    if (searchdata.device_online !== '' && searchdata.device_online != null) obj.device_online = String(searchdata.device_online)
    if (searchdata.device_category !== '' && searchdata.device_category != null) obj.device_category = String(searchdata.device_category)
    obj.page = searchdata.page
    obj.page_size = searchdata.page_size
    newphonelist(obj).then((response) => {
        if (response.data.msg.code == 0) {
            tableData.data = response.data.data.list.data
            total.value = response.data.data.list.total
            statCard.total = response.data.data.total_devices || 0
            statCard.online = response.data.data.online_devices || 0
            statCard.offline = response.data.data.offline_devices || 0
            statCard.disabled = response.data.data.disabled_devices || 0
        }
    })
}
// 分页
const page_change = (val) => {
    searchdata.page = val
    getlist()
}

// 行样式：设备停用变灰
const rowClassName = ({ row }) => (row.device_status == 1 ? '' : 'row-off')

// 类别展示
const catName = (t) => (t == 1 ? '客服' : t == 2 ? '营销' : '—')
const catClass = (t) => (t == 1 ? 'badge-cat-agent' : t == 2 ? 'badge-cat-mkt' : '')

// 提交数据
const formdata = reactive({
    id: '',
    imei: '',
    device_code: '',
    device_name: '',
    device_type: '',
    device_category: '',
    device_status: '',
    corp_id: '',
    wx_user_id: '',
    wx_name: '',
})
// 弹窗是否显示
const isshowadd = ref(false)
// 打开弹窗
const openwindow = (row) => {
    isshowadd.value = true
    if (row) {
        formdata.id = row.id
        formdata.imei = row.imei
        formdata.device_code = row.device_code
        formdata.device_name = row.device_name
        formdata.device_type = row.device_type
        // 类别仅在为 1(客服)/2(营销) 时回显，否则为空，以用户修改的值为准
        formdata.device_category = row.device_category == 1 || row.device_category == 2 ? row.device_category : ''
        formdata.device_status = row.device_status
        formdata.corp_id = row.corp_id
        formdata.wx_user_id = row.wx_user_id
        formdata.wx_name = row.wx_name
    } else {
        Object.assign(formdata, {
            id: '', imei: '', device_code: '', device_name: '',
            device_type: '', device_category: '', device_status: '', corp_id: '', wx_user_id: '', wx_name: '',
        })
    }
}
// 提交
const suresub = () => {
    if (!formdata.device_name) {
        ElMessage({ type: 'warning', message: '请输入手机别名' })
        return
    }
    if (formdata.device_category !== 1 && formdata.device_category !== 2) {
        ElMessage({ type: 'warning', message: '请选择设备类别' })
        return
    }
    if (formdata.id == '') {
        newaddphone(formdata).then((response) => {
            if (response.data.msg.code == 0) {
                ElMessage({ type: 'success', message: '操作成功' })
                searchdata.page = 1
                getlist()
                isshowadd.value = false
            }
        })
    } else {
        newupdatesimple({
            device_category: formdata.device_category,
            device_name: formdata.device_name,
            id: formdata.id,
        }).then((response) => {
            if (response.data.msg.code == 0) {
                ElMessage({ type: 'success', message: '操作成功' })
                getlist()
                isshowadd.value = false
            }
        })
    }
}

// 删除弹窗
const isshowdel = ref(false)
const delrow = reactive({ data: {} })
const delbtn = (row) => {
    delrow.data = row
    isshowdel.value = true
}
const confirmdel = () => {
    newdelphone({ id: delrow.data.id }).then((response) => {
        if (response.data.msg.code == 0) {
            ElMessage({ type: 'success', message: '操作成功' })
            isshowdel.value = false
            getlist()
        }
    })
}
</script>
<style scoped>
.pt-wrap {
    font-size: 14px;
}
/* ---------- 标题 ---------- */
.page-title { font-size: 21px; font-weight: 800; margin: 4px 0 18px; }
.page-title small { font-weight: 500; color: #64748B; font-size: 14px; margin-left: 10px; }
/* ---------- 统计卡片 ---------- */
.stat-row { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin-bottom: 18px; }
.stat-card { background: #fff; border-radius: 14px; box-shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .06); padding: 16px 18px; }
.stat-label { font-size: 12.5px; color: #64748B; font-weight: 600; }
.stat-label .dot { display: inline-block; width: 8px; height: 8px; border-radius: 50%; margin-right: 6px; vertical-align: middle; }
.stat-value { font-size: 28px; font-weight: 800; color: #1E293B; margin-top: 4px; line-height: 1; }
.stat-value .unit { font-size: 14px; font-weight: 600; color: #64748B; margin-left: 4px; }
.stat-sub { font-size: 12px; color: #64748B; margin-top: 6px; }
/* ---------- 工具栏 ---------- */
.toolbar { display: flex; align-items: center; gap: 12px; margin-bottom: 14px; flex-wrap: wrap; }
.toolbar .spacer { flex: 1; }
.search-box { width: 260px; }
:deep(.toolbar .el-select__wrapper),
:deep(.toolbar .el-input__wrapper) {
    background: #fff;
    box-shadow: 0 0 0 1px #E8ECF3 inset;
    border-radius: 10px;
    min-height: 36px;
}
.seg-filter { display: inline-flex; gap: 2px; background: #F1F3F9; border-radius: 10px; padding: 3px; }
.sf-btn { border: 0; background: transparent; padding: 6px 14px; border-radius: 8px; font-size: 12.5px; font-weight: 600; color: #64748B; cursor: pointer; }
.sf-btn:hover { color: #1E293B; }
.sf-btn.active { background: #fff; color: #4F46E5; box-shadow: 0 1px 2px rgba(0, 0, 0, .08); }
/* ---------- 按钮 ---------- */
.btn-primary {
    background: linear-gradient(90deg, #4F46E5, #7C3AED); color: #fff; border: 0;
    border-radius: 10px; padding: 9px 18px; font-weight: 700; cursor: pointer; font-size: 13px;
    display: inline-flex; align-items: center; gap: 6px;
}
.btn-primary:hover { opacity: .92; }
.btn-ghost { background: #F1F3F9; color: #1E293B; border: 0; border-radius: 10px; padding: 9px 18px; font-weight: 600; font-size: 13px; }
.btn-ghost:hover { background: #E7EAF2; }
.btn-danger { background: linear-gradient(90deg, #EF4444, #DC2626); color: #fff; border: 0; border-radius: 10px; padding: 9px 18px; font-weight: 700; font-size: 13px; }
.btn-danger:hover { opacity: .92; }
/* ---------- 表格 ---------- */
.table-wrap { background: #fff; border-radius: 14px; box-shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .06); padding: 6px 4px; overflow: hidden; }
:deep(.seg-table.el-table) { font-size: 13.5px; }
:deep(.seg-table .el-table__header th) {
    padding: 14px 18px; color: #64748B; font-weight: 700; font-size: 12.5px;
    background: #FBFCFE; border-bottom: 1px solid #E8ECF3; white-space: nowrap;
}
:deep(.seg-table .el-table__body td) { padding: 15px 18px; border-bottom: 1px solid #EEF1F6; vertical-align: middle; }
:deep(.seg-table .el-table__row:hover > td) { background: #F8FAFF; }
:deep(.seg-table .el-table__row.row-off > td) { color: #64748B; }
:deep(.seg-table .el-table__row.row-off .mono) { color: #64748B; }
.mono { font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace; font-size: 12.5px; }
.cell-strong { font-weight: 700; color: #1E293B; }
.muted-cell { color: #64748B; }
/* ---------- 徽标 ---------- */
.badge { display: inline-block; font-size: 11.5px; font-weight: 700; padding: 3px 10px; border-radius: 999px; line-height: 1.5; text-align: center; }
.badge-cat-agent { color: #4F46E5; background: rgba(79, 70, 229, .10); }
.badge-cat-mkt { color: #7C3AED; background: rgba(124, 58, 237, .10); }
.ops-badge { display: inline-flex; align-items: center; gap: 6px; font-size: 12px; font-weight: 700; padding: 4px 11px; border-radius: 999px; line-height: 1.4; }
.ops-badge::before { content: ""; width: 6px; height: 6px; border-radius: 50%; background: currentColor; flex-shrink: 0; }
.ops-badge-online { color: #10B981; background: rgba(16, 185, 129, .12); }
.ops-badge-offline { color: #64748B; background: rgba(100, 116, 139, .12); }
/* ---------- 操作 ---------- */
.ops-row-actions { display: flex; align-items: center; gap: 4px; white-space: nowrap; }
.ops-link { color: #4F46E5; font-weight: 600; cursor: pointer; font-size: 13px; background: none; border: 0; padding: 4px 10px; border-radius: 6px; font-family: inherit; white-space: nowrap; }
.ops-link:hover { background: rgba(79, 70, 229, .08); }
.ops-link.danger { color: #EF4444; }
.ops-link.danger:hover { background: rgba(239, 68, 68, .08); }
/* ---------- 分页 ---------- */
.pager { display: flex; align-items: center; justify-content: flex-end; padding: 14px 16px; }
:deep(.pager .el-pagination) { display: flex; align-items: center; }
:deep(.pager .el-pagination__total) { color: #64748B; font-size: 13px; margin-right: 10px; }
:deep(.pager .btn-prev),
:deep(.pager .btn-next) {
    background: #fff; border: 1px solid #E8ECF3; border-radius: 8px; color: #1E293B;
    font-weight: 600; font-size: 13px; min-width: auto; padding: 0 12px; height: 32px; line-height: 30px;
}
:deep(.pager .btn-prev) { margin-right: 8px; }
:deep(.pager .btn-prev:hover:not(:disabled)),
:deep(.pager .btn-next:hover:not(:disabled)) { border-color: #4F46E5; color: #4F46E5; }
:deep(.pager .btn-prev:disabled),
:deep(.pager .btn-next:disabled) { opacity: .5; background: #fff; color: #1E293B; cursor: not-allowed; }
/* ---------- 弹窗 ---------- */
:deep(.el-dialog) { border-radius: 14px; padding: 0; overflow: hidden; }
:deep(.el-dialog__header) { padding: 16px 22px; border-bottom: 1px solid #E8ECF3; margin-right: 0; }
:deep(.el-dialog__title) { font-size: 15.5px; font-weight: 800; color: #1E293B; }
:deep(.el-dialog__body) { padding: 18px 22px; }
:deep(.el-dialog__footer) { padding: 0 22px 20px; }
.dialog-foot { display: flex; gap: 10px; }
.dialog-foot .el-button { flex: 1; margin-left: 0; }
/* ---------- 表单 ---------- */
.form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px 16px; }
.form-row.full { grid-column: 1 / -1; }
.form-label { display: block; font-size: 12.5px; font-weight: 700; color: #64748B; margin-bottom: 6px; }
.form-label .req { color: #EF4444; margin-left: 2px; }
.form-input {
    width: 100%; border: 1px solid #E8ECF3; border-radius: 10px; padding: 9px 12px;
    font-size: 13.5px; font-family: inherit; color: #1E293B; background: #fff; box-sizing: border-box;
    transition: border-color .15s, box-shadow .15s;
}
.form-input:focus { outline: none; border-color: #4F46E5; box-shadow: 0 0 0 3px rgba(79, 70, 229, .10); }
.form-input[readonly] { background: #F6F7FB; color: #64748B; cursor: not-allowed; }
.form-hint { font-size: 11.5px; color: #64748B; margin-top: 5px; }
:deep(.form-row .el-select__wrapper) { background: #fff; box-shadow: 0 0 0 1px #E8ECF3 inset; border-radius: 10px; min-height: 36px; }
/* ---------- 删除弹窗 ---------- */
.del-title { margin: 0 0 14px; font-size: 16px; color: #1E293B; }
.del-text { color: #64748B; margin: 6px 0; font-size: 13.5px; line-height: 1.6; }
.del-text b { color: #1E293B; }
.alert-warn { display: flex; gap: 10px; background: rgba(245, 158, 11, .09); border: 1px solid rgba(245, 158, 11, .30); border-radius: 10px; padding: 11px 13px; margin-top: 12px; }
.alert-warn > svg { flex-shrink: 0; margin-top: 1px; color: #F59E0B; }
.alert-warn b { display: block; font-size: 13px; color: #92400E; margin-bottom: 3px; }
.alert-warn p { margin: 0; font-size: 12.5px; color: #92400E; line-height: 1.65; }
@media (max-width: 1180px) { .stat-row { grid-template-columns: repeat(2, 1fr); } }
</style>